import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDualMsal } from "../contexts/MsalContext";
import { CircularProgress, Box } from "@mui/material";

export default function SecureRoute({ element, roleRequired }) {
  const { currentUser, isInitialized, isAuthenticated } = useDualMsal();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  
  console.log(`SecureRoute mounted: path=${location.pathname}, roleRequired=${JSON.stringify(roleRequired)}, isInitialized=${isInitialized}, isAuthenticated=${isAuthenticated}`);
  
  // Check for authentication parameters in the URL
  const hasAuthParams = 
    location.hash.includes('id_token=') || 
    location.hash.includes('access_token=') ||
    location.search.includes('code=') || 
    location.search.includes('error=');
    
  useEffect(() => {
    // Skip authorization check if not yet initialized or handling auth params
    if (!isInitialized || hasAuthParams) {
      return;
    }
    
    // At this point, initialization is complete and we can make authorization decisions
    if (!isAuthenticated || !currentUser) {
      // User is definitely not authenticated
      console.log(`SecureRoute[${location.pathname}]: User is not authenticated`);
      setAuthorized(false);
      setLoading(false);
      return;
    }
    
    // User is authenticated, check if they have the required role
    if (roleRequired && roleRequired.length > 0) {
      const hasRequiredRole = roleRequired.some(role => currentUser.roles?.includes(role));
      console.log(`SecureRoute[${location.pathname}]: Checking roles:`, currentUser.roles, 'Required:', roleRequired, 'Has required role:', hasRequiredRole);
      
      setAuthorized(hasRequiredRole);
      setLoading(false);
    } else {
      // No specific roles required, user is authorized
      setAuthorized(true);
      setLoading(false);
    }
  }, [currentUser, hasAuthParams, isInitialized, isAuthenticated, location.pathname, roleRequired]);
  
  // Show loading while context is initializing or during auth params handling
  if (!isInitialized || hasAuthParams || loading) {
    console.log(`SecureRoute[${location.pathname}]: Showing loading indicator - isInitialized=${isInitialized}, hasAuthParams=${hasAuthParams}, loading=${loading}`);
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: 'calc(100vh - 64px)' 
      }}>
        <CircularProgress />
      </Box>
    );
  }
  
  // If authorized, render the protected component
  if (authorized) {
    console.log(`SecureRoute[${location.pathname}]: Rendering protected component`);
    return element;
  }
  
  // Otherwise, redirect to home
  console.log(`SecureRoute[${location.pathname}]: Redirecting to home`);
  return <Navigate to="/" replace />;
}
